const updateProgress = (elem) => {
  const count = Number(elem.dataset.count);
  const total = Number(elem.dataset.total);
  const progress = (count / total) * 100;
  elem.style.width = `${progress}%`;
};

export default updateProgress;
